import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IDrawing } from 'lightweight-charts-drawing';
import { ChartDrawingController } from '../chart-drawing-controller';
import { getToolIcon, getToolLabel } from '../drawing-tools.catalog';
import { TemaService } from 'src/app/services/tema.services';

@Component({
  selector: 'app-drawing-object-tree',
  templateUrl: './drawing-object-tree.component.html',
  styleUrls: ['./drawing-object-tree.component.scss'],
})
export class DrawingObjectTreeComponent implements OnInit, OnDestroy {
  @Input() controller!: ChartDrawingController;

  public isDark = false;
  public open = false;
  public drawings: IDrawing[] = [];
  public selectedId: string | null = null;

  private subs: Subscription[] = [];

  constructor(private temaService: TemaService) {}

  ngOnInit(): void {
    this.subs.push(
      this.temaService.valDarkTheme.subscribe(v => (this.isDark = v)),
      this.controller.objectTreeOpen$.subscribe(v => (this.open = v)),
      this.controller.drawings$.subscribe(list => (this.drawings = list)),
      this.controller.selection$.subscribe(d => (this.selectedId = d?.id ?? null)),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  public close(): void {
    this.controller.objectTreeOpen$.next(false);
  }

  public label(drawing: IDrawing): string {
    return getToolLabel(drawing.type);
  }

  public icon(drawing: IDrawing): string {
    return getToolIcon(drawing.type);
  }

  public isVisible(drawing: IDrawing): boolean {
    return drawing.options.visible !== false;
  }

  public isLocked(drawing: IDrawing): boolean {
    return drawing.options.locked === true;
  }

  public select(drawing: IDrawing): void {
    this.controller.selectById(drawing.id);
  }

  public toggleVisible(drawing: IDrawing, e: Event): void {
    e.stopPropagation();
    this.controller.toggleVisible(drawing.id);
  }

  public toggleLock(drawing: IDrawing, e: Event): void {
    e.stopPropagation();
    this.controller.toggleLock(drawing.id);
  }

  public remove(drawing: IDrawing, e: Event): void {
    e.stopPropagation();
    this.controller.removeById(drawing.id);
  }
}
